var _defs, _style, _path, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGateLog({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    width: 28,
    height: 28,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ellipse 56-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 20,
    height: 20,
    id: "img2",
    href: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIwIDEwQzIwIDExLjMxMzIgMTkuNzQxMyAxMi42MTM2IDE5LjIzODggMTMuODI2OEMxOC43MzYyIDE1LjA0MDEgMTcuOTk5NyAxNi4xNDI1IDE3LjA3MTEgMTcuMDcxMUMxNi4xNDI1IDE3Ljk5OTcgMTUuMDQwMSAxOC43MzYyIDEzLjgyNjggMTkuMjM4OEMxMi42MTM2IDE5Ljc0MTMgMTEuMzEzMiAyMCAxMCAyMFYxMEgyMFoiIGZpbGw9IiMwMDU4NTciLz4KPHBhdGggZD0iTTEwIDIwQzguNjg2NzggMjAgNy4zODY0MiAxOS43NDEzIDYuMTczMTcgMTkuMjM4OEM0Ljk1OTkxIDE4LjczNjIgMy44NTc1MiAxNy45OTk3IDIuOTI4OTMgMTcuMDcxMUMyLjAwMDM1IDE2LjE0MjUgMS4yNjM3NSAxNS4wNDAxIDAuNzYxMjA0IDEzLjgyNjhDMC4yNTg2NTcgMTIuNjEzNiAtMS4xNDgwNWUtMDcgMTEuMzEzMiAwIDEwTDEwIDEwVjIwWiIgZmlsbD0iI0E5MDgyMSIvPgo8cGF0aCBkPSJNMCAxMEMyLjMxODZlLTA3IDcuMzQ3ODMgMS4wNTM1NyA0LjgwNDMgMi45Mjg5MyAyLjkyODkzQzQuODA0MyAxLjA1MzU3IDcuMzQ3ODQgLTMuMTYyNjdlLTA4IDEwIDBWMTBMMCAxMFoiIGZpbGw9IiNGQzlEMkMiLz4KPHBhdGggZD0iTTEwIDBDMTEuMzEzMiAxLjU2NmUtMDggMTIuNjEzNiAwLjI1ODY1OCAxMy44MjY4IDAuNzYxMjA1QzE1LjA0MDEgMS4yNjM3NSAxNi4xNDI1IDIuMDAwMzUgMTcuMDcxMSAyLjkyODkzQzE3Ljk5OTcgMy44NTc1MiAxOC43MzYyIDQuOTU5OTEgMTkuMjM4OCA2LjE3MzE3QzE5Ljc0MTMgNy4zODY0MiAyMCA4LjY4Njc4IDIwIDEwTDEwIDEwVjBaIiBmaWxsPSIjMDA3QTlFIi8+Cjwvc3ZnPgo="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff;stroke: #81818c } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m14 27.5c-7.5 0-13.5-6-13.5-13.5c0-7.5 6-13.5 13.5-13.5c7.5 0 13.5 6 13.5 13.5c0 7.5-6 13.5-13.5 13.5z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Group 48",
    href: "#img2",
    transform: "matrix(1,0,0,1,4,4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGateLog);
export default __webpack_public_path__ + "static/media/GateLog.75e6ee8f.svg";
export { ForwardRef as ReactComponent };